<template>
   <div style="margin-top:5px;border: 1px solid #ddd;border-bottom:0px;">
     <div style="background-color: #ececec;line-height:35px;padding-left:5px;">
       {{$lang("意见列表")}}：<el-button @click="refreshComment($event)"><i class="fa fa-refresh"></i>{{$lang("刷新")}}</el-button>
       <el-button @click="showFlowChatDialog($event)"><i class="fa fa-eye"></i>{{$lang("流程图示")}}</el-button>
       <el-button @click="showTransactionDialog($event)"><i class="fa fa-sitemap"></i>{{$lang("办理过程")}}</el-button>
       <el-button @click="showOperationRecordDialog($event)" v-if="!hideOprLog"><i class="fa fa-sitemap"></i>{{$lang("操作记录")}}</el-button>
       <el-button icon="fa fa-chevron-up" v-if="showTable" @click="showTable =!showTable" style="float:right;background:none;border:none;margin-top: 2px;padding:7px 3px"></el-button>
       <el-button icon="fa fa-chevron-down" v-else @click="showTable =!showTable" style="float:right;background:none;border:none;margin-top: 2px;padding:7px 3px"></el-button>
     </div>
     <mw-table :api="api" :columns="columns" :pagination="false" ref="commentTable" v-show="showTable"
          :nowrap="false"   :defaultParams="defaultParams" :defaultParamsAutoLoad="true" :autoLoad="false"></mw-table>
   </div>

</template>
<script>
  export default
  {
    name:'form-comment-list',
    data() {
      let me=this;
      return {
        api:'business.listComment',
        hideOprLog:window.$Env && $Env.hideCommentlistOperation,
        defaultParams:{
          businessId:'',
          requireHidden:true,
          excludeHidden:'2'
        },
        columns: [
          {type: 'index'},
          {prop: 'taskName',tooltip:true, label: $lang('节点名称'),width: '120',formatter:me.taskNameFormatter},
          {prop: 'department',tooltip:true, label: $lang('办理部门'),width: '150',formatter:me.depFormatter},
          {prop: 'content', label: $lang('意见内容')},
          {prop: 'creator', label: $lang('姓名'),width:'120',formatter:me.creatorFormatter},
          {prop: 'createTime',label: $lang('填写时间'),width: '170'}
        ],
        // 折叠表格面板
        showTable:true
      }
    },
    created() {

    },
    mounted() {
      this.refreshComment();
    },
    methods: {
      taskNameFormatter(row, col, cellValue) {
        return $lang(cellValue)
      },
      depFormatter(row, col, cellValue) {
        let isEn = window.$currentBrowserLanguage === 'en';
        if(isEn){
          return row.departmentEnglishname || cellValue;
        }else{
          return cellValue;
        }
      },
      creatorFormatter(row, col, cellValue) {
        let isEn = window.$currentBrowserLanguage === 'en';
        if(isEn){
          return row.Englishname || cellValue;
        }else{
          return cellValue;
        }
      },
      refreshComment(event){
        if(event){
          event.stopPropagation();
        }
        this.defaultParams.businessId=this.$options.params.businessId;

        this.mwRef('commentTable').refresh();
      },

      showTransactionDialog(event){
        event.stopPropagation();
        let me = this;
        PF.showPage({id:"f0a951bda707bed2",size:'large_large',title:$lang('办理过程'),businessId:this.$options.params.businessId, batchId:me.$options.params.batchId});
       // PF.show('transactionProcess',{batchId:me.$options.params.batchId, taskId:me.$options.params.taskId});
      },
      showOperationRecordDialog(event){
        event.stopPropagation();
        let me = this;
        PF.show('processOperationRecord',{batchId:me.$options.params.batchId});
      },
      showFlowChatDialog(event){
        event.stopPropagation();
        let me = this;
        PF.func.bpm.showFlowImage({businessId:me.$options.params.businessId,batchId:me.$options.params.batchId, applicationId:me.$options.params.appId,processDefinitionId:me.$options.params.processDefinitionId, taskId:me.$options.params.taskId}, this);
      },
    },
    destroyed(){

    }
  }
</script>




// WEBPACK FOOTER //
// src/common/components/extend/form/src/components/comment.vue